import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const isDriverValidForScheduling = (data: {
  load: {
    deliveries: { location: { pump_required: boolean } }[]
    pickups: { terminal: { id: number; name: string } }[]
  }
  schedules: { id: number; time_off: boolean }[]
  driver: {
    full_name: string
    schedule_trailer: { trailer_type: string; pump_equipped: boolean }
    schedule_truck: { serial_number: string; pump_equipped: boolean }
    schedule_id: number
    carded_terminals: { id: number }[]
  }
}) => {
  try {
    const errorTexts = []
    const { load, schedules, driver } = data
    const loadTerminalIds = (load?.pickups ?? [])
      .map((p) => p.terminal.id)
      .filter((id) => id !== null && id !== undefined)
    const pumpNeeded = (load?.deliveries ?? []).some(
      (d) => d.location?.pump_required
    )
    const allowedTerminalIds = (driver?.carded_terminals ?? [])
      .map((t) => t.id)
      .filter(Boolean)

    if (
      allowedTerminalIds.length &&
      loadTerminalIds.some((id) => !allowedTerminalIds.includes(id))
    ) {
      const unauthorizedPickup = load?.pickups?.find(
        (p) => !allowedTerminalIds.includes(p.terminal.id)
      )

      errorTexts.push(
        `Driver ${driver?.full_name ?? ""} is not authorized for Terminal ${
          unauthorizedPickup?.terminal?.name ?? unauthorizedPickup?.terminal?.id
        }`
      )
    }

    if (pumpNeeded) {
      if (
        driver?.schedule_trailer &&
        driver?.schedule_truck &&
        !driver.schedule_trailer.pump_equipped &&
        !driver.schedule_truck.pump_equipped
      ) {
        errorTexts.push(
          `This assignment requires pump equipment, but Trailer ${
            driver.schedule_trailer.trailer_type || ""
          } and Truck ${
            driver.schedule_truck.serial_number || ""
          } are not equipped`
        )
      }
      // Needed in edit load dropdown as truck and trailer are separate fields
      if (
        driver?.schedule_trailer &&
        !driver?.schedule_truck &&
        !driver.schedule_trailer.pump_equipped
      ) {
        errorTexts.push(
          `This assignment requires pump equipment, but Trailer ${
            driver.schedule_trailer.trailer_type || ""
          } is not equipped`
        )
      }

      if (
        driver?.schedule_truck &&
        !driver?.schedule_trailer &&
        !driver.schedule_truck.pump_equipped
      ) {
        errorTexts.push(
          `This assignment requires pump equipment, but Truck ${
            driver.schedule_truck.serial_number || ""
          } is not equipped`
        )
      }
    }

    const schedule = (schedules ?? []).find((s) => s.id === driver?.schedule_id)
    if (schedule?.time_off) {
      errorTexts.push(
        `Driver ${
          driver?.full_name ?? ""
        } is scheduled to be off during this assignment`
      )
    }

    return errorTexts
  } catch (error) {
    console.error(error)
    return []
  }
}

const INTERACTIVE_SELECTOR =
  "button, a, input, select, textarea, [role='button'], [role='menuitem'] [contenteditable='true']"
export function isInteractiveTarget(e: React.MouseEvent<HTMLElement>): boolean {
  return (
    e.target instanceof Element &&
    e.target.closest(INTERACTIVE_SELECTOR) !== null
  )
}
